import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
  InputAdornment,
  Typography,
} from "@mui/material";
import api from "../api/axios";
import Swal from "sweetalert2";

const ChangePassword = ({ open, onClose, userLogged }) => {
  const [passwords, setPasswords] = useState({
    password: "",
    password_confirmation: "",
    showPassword: false,
    showConfirm: false,
  });

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  const showLoading = (text = "Procesando...") => {
    Swal.fire({
      title: text,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
  };

  const handleOtpChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value && index < 5)
        document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const sendOtp = async () => {
    showLoading("Enviando código...");
    try {
      const res = await api.post(`${process.env.REACT_APP_API_URL}/send-otp`, {
        email,
      });
      Swal.fire("Código enviado", "Revisa tu bandeja de entrada", "success");
      setStep(2);
    } catch (e) {
      console.error("Error enviando OTP:", e);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          e?.response?.data?.message ||
          "No se pudo enviar el código. Verifica el correo.",
      });
    }
  };

  const verifyOtp = async () => {
    const code = otp.join("");
    showLoading("Verificando código...");
    try {
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/verify-otp`,
        { email, otp: code },
      );
      Swal.fire("Código válido", "Puedes continuar", "success");
      setStep(3);
    } catch (e) {
      console.error("   Error verificando OTP:", e);
      Swal.fire({
        icon: "error",
        title: "Código incorrecto",
        text:
          e?.response?.data?.error ||
          e?.response?.data?.message ||
          "Intenta nuevamente",
      });
    }
  };

  const resetPassword = async () => {
    const flag = userLogged?.email == email;

    if (flag || step === 3) {
      const code = otp.join("");
      showLoading("Actualizando contraseña...");
      try {
        const res = await api.post(
          `${process.env.REACT_APP_API_URL}/reset-password`,
          {
            email,
            otp: code,
            password: passwords.password,
            password_confirmation: passwords.password_confirmation,
          },
        );
        Swal.fire("Contraseña actualizada", "", "success");
        onClose();
      } catch (e) {
        console.error("   Error cambiando contraseña:", e);
        Swal.fire({
          icon: "error",
          title: "Error",
          text:
            e?.response?.data?.error ||
            e?.response?.data?.message ||
            "No se pudo cambiar la contraseña.",
        });
      }
    } else {
      console.log(
        "El email que has ingresado no coincide con el email del usuario",
      );
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "El email que has ingresado no coincide con el email del usuarios",
      });
    }
  };

  // ======================
  // VALIDACIÓN DE CONTRASEÑA
  // ======================
  const passwordError = () => {
    if (!passwords.password) return "";
    if (passwords.password.length < 6)
      return "La contraseña debe tener al menos 6 caracteres";
    if (passwords.password !== passwords.password_confirmation)
      return "Las contraseñas no coinciden";
    return "";
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Recuperar Contraseña</DialogTitle>

      <DialogContent sx={{ minWidth: 350 }}>
        {step === 1 && (
          <>
            <p>Ingresa tu email y te enviaremos el código de verificación.</p>
            <TextField
              label="Correo"
              size="small"
              fullWidth
              sx={{ mt: 2 }}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </>
        )}

        {step === 2 && (
          <>
            <p>Ingresa el código enviado a tu correo.</p>
            <Box
              sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 2 }}
            >
              {otp.map((num, i) => (
                <TextField
                  key={i}
                  id={`otp-${i}`}
                  value={num}
                  onChange={(e) => handleOtpChange(e.target.value, i)}
                  inputProps={{
                    maxLength: 1,
                    style: { textAlign: "center", fontSize: "20px" },
                  }}
                  sx={{ width: 45 }}
                />
              ))}
            </Box>
          </>
        )}

        {step === 3 && (
          <>
            <p>Ingresa tu nueva contraseña.</p>

            <TextField
              label="Nueva contraseña"
              type={passwords.showPassword ? "text" : "password"}
              size="small"
              fullWidth
              sx={{ mt: 2 }}
              value={passwords.password}
              onChange={(e) =>
                setPasswords({ ...passwords, password: e.target.value })
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      onClick={() =>
                        setPasswords((prev) => ({
                          ...prev,
                          showPassword: !prev.showPassword,
                        }))
                      }
                      size="small"
                    >
                      {passwords.showPassword ? "Ocultar" : "Mostrar"}
                    </Button>
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label="Confirmar contraseña"
              type={passwords.showConfirm ? "text" : "password"}
              size="small"
              fullWidth
              sx={{ mt: 2 }}
              value={passwords.password_confirmation}
              onChange={(e) =>
                setPasswords({
                  ...passwords,
                  password_confirmation: e.target.value,
                })
              }
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Button
                      onClick={() =>
                        setPasswords((prev) => ({
                          ...prev,
                          showConfirm: !prev.showConfirm,
                        }))
                      }
                      size="small"
                    >
                      {passwords.showConfirm ? "Ocultar" : "Mostrar"}
                    </Button>
                  </InputAdornment>
                ),
              }}
            />

            {passwordError() && (
              <Typography color="error" variant="body2" sx={{ mt: 1 }}>
                {passwordError()}
              </Typography>
            )}
          </>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "space-between" }}>
        <Button onClick={onClose} color="error">
          Cancelar
        </Button>

        {step === 1 && (
          <>
            <Button
              onClick={() => setStep(2)}
              disable
              variant={"outlined"}
              d={!email}
              color="inherit"
            >
              Ya tengo un código
            </Button>

            <Button
              onClick={sendOtp}
              variant="contained"
              color="success"
              disabled={!email}
            >
              Enviar código
            </Button>
          </>
        )}

        {step === 2 && (
          <>
            <Button
              onClick={() => {
                setStep(1);
                setOtp(["", "", "", "", "", ""]);
              }}
              variant={"outlined"}
              color="inherit"
            >
              Volver a enviar código
            </Button>

            <Button
              onClick={verifyOtp}
              variant="contained"
              color="success"
              disabled={otp.join("").length !== 6}
            >
              Verificar
            </Button>
          </>
        )}

        {step === 3 && (
          <>
            <Button
              onClick={() => {
                setStep(1);
                setOtp(["", "", "", "", "", ""]);
              }}
              variant={"outlined"}
              color="inherit"
            >
              Volver a enviar código
            </Button>
            <Button
              onClick={resetPassword}
              variant="contained"
              color="success"
              disabled={!!passwordError()}
            >
              Cambiar contraseña
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ChangePassword;
